<div class="abstract-dialog abstract-dialog__width-{{dialogWidth}}" cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
     [ngClass]="{'padding-off': paddingOff}"
     [ngStyle]="{'overflow-y': 'overlay'}">
    <div role="banner" class="abstract-dialog__header">
        <div class="abstract-dialog__header__tts-buttons" *ngIf="showVoiceControls">
            <app-button
                    [ariaLabel]="((ttsIconState === defaultIconState ? 'SCREEN_READER.HEADER.PLAY_BUTTON' : 'SCREEN_READER.HEADER.PAUSE_BUTTON') | translate) + ('GENERAL.BUTTON' | translate)"
                    [cssClasses]="'icon'"
                    [iconState]="ttsIconState ? ttsIconState : defaultIconState"
                    [iconSize]="'36'"
                    [iconColor]="'blue-08'"
                    [disabled]="!(patientRole && playButtonActive)"
                    (buttonClicked)="readText()">
            </app-button>
            <app-button
                    [ariaLabel]="('SCREEN_READER.HEADER.REPEAT_BUTTON' | translate) + ('GENERAL.BUTTON' | translate)"
                    [cssClasses]="'icon'"
                    [icon]="'replay'"
                    [iconColor]="'blue-08'"
                    [iconSize]="'36'"
                    [disabled]="!(patientRole && repeatButtonActive)"
                    (buttonClicked)="playAudio()">
            </app-button>
        </div>
        <div class="abstract-dialog__header__close-icon" *ngIf="showCloseButton">
            <app-button
                    [ariaLabel]="('GENERAL.CLOSE' | translate) + 'dialog' +  ('GENERAL.BUTTON' | translate)"
                    [cssClasses]="'icon-padding'"
                    [icon]="'close'"
                    [iconColor]="'gray-08'"
                    (buttonClicked)="close()">
            </app-button>
        </div>
        <div class="abstract-dialog__header__title-box">
            <ng-content select="[abstract-header]"></ng-content>
        </div>
    </div>

    <div role="main" class="abstract-dialog__content">
        <ng-content select="[abstract-content]"></ng-content>
    </div>

    <div role="contentinfo" class="abstract-dialog__footer">
        <ng-content select="[abstract-footer]"></ng-content>
    </div>
</div>
